module.exports = __webpack_public_path__ + "img/arrow-light.914b61ea.svg";